import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { PosConfigurationItem } from 'src/models/pos-configuration/_types';

export const getIcon = (type: PosConfigurationItem['itemType']) => {
  switch (type) {
    case 'product':
      return icon({ name: 'tag', style: 'regular' });
    case 'group':
      return icon({ name: 'users', style: 'regular' });
    case 'package':
      return icon({ name: 'box', style: 'regular' });
    case 'plan':
      return icon({ name: 'list', style: 'regular' });
    default:
      return icon({ name: 'tag', style: 'regular' });
  }
};
